import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../../createApiConfig';

export const lmIptvStatusApi = createApi({
  reducerPath: 'lmIptvStatusApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['IPTV status '],
  endpoints: builder => ({
    getIptvStatus: builder.query({
      query: (params) => ({
        url: `/links/iptv-status/`,
        params,
      }),
      providesTags: ['IPTV status '],
    }),

    createIptvStatus: builder.mutation({
      query: (data) => ({
        url: '/links/iptv/iptv-status',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['IPTV status '],
    }),

   
  }),
});

export const {
  useGetIptvStatusQuery,
  useCreateIptvStatusMutation,
} = lmIptvStatusApi;
